import React, { useState, useEffect } from "react";
import { Mosaic, MosaicWindow, updateTree } from "react-mosaic-component";
import "react-mosaic-component/react-mosaic-component.css";
import LiveHighChart from "./Split";
import { useLayout } from "../Context/LayoutContext";
import { BarsOutlined } from "@ant-design/icons";
import DropDown from "./DropDown";
import { motion, AnimatePresence } from "framer-motion";
import { clearTimeout } from "highcharts";
import { Loader } from "../Loader/Loader";
import Forexchart from "./Forexchart";


export default function TradeLayout({ setActiveTabType }) {
  // const [value, setValue] = useState(layouts[10].layout);
  const {
    currentLayout,
    onEdit,
    setCurrentLayout,
    tabs,
    showDrawer,
    loadingCharts,
    activeKey,
    setIsMatchedIndex,
    prevActiveKey,
  } = useLayout();

  return (
    <div style={{ flex: 1 }}>
      <Mosaic
        // renderTile={(id, path) => {
        //     const tab = tabs.find(t => t.key === id);
        //     console.log(path, 'path');
        // key={activeKey}
        resize={{ minimumPaneSizePercentage: 40 }}
        renderTile={(id, path) => {
          const isCompactTile = String(id).includes("-compact");

          // remove "-compact" part
          const cleanId = String(id).replace("-compact", "");

          // extract base chartId and index (from pattern "something_index")
          const [chartId, chartIndexStr] = cleanId.split("_");

          // convert to number safely
          const chartIndex = Number(chartIndexStr);
          setIsMatchedIndex(chartIndex);

          // ✅ dynamic logic with duplicate protection
          const activeTab = tabs.find((t) => t.key === activeKey);
          const otherTabs = tabs.find((t, idx) => idx === chartIndex);
          const tab = otherTabs;

          setActiveTabType(tab?.typ);



          return (
            <MosaicWindow
              path={path}
              className={tab?.typ === 'future' ? "mosia-barhide hide-tool" : "mosia-barhide ar3"}
              style={{ overflow: tab?.typ === 'forex' ? "hidden" : "scroll", }}
              // title={"Chart"}
              renderToolbar={(props) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    background: "transparent",
                    padding: "4px 8px",
                    overflow: tab?.typ === 'forex' ? "scroll" : "hidden",

                  }}

                >
                  {/* Close Button only */}
                  {props.connectDragSource(
                    <span
                      style={{
                        cursor: "pointer",
                        color: "red",
                        fontWeight: "bold",
                        marginRight: "8px",
                        display: (!tab || tabs.length <= 1) && "none",
                      }}
                      onClick={() => onEdit(tab.key, "remove")}
                    >
                      ✖
                    </span>
                  )}
                </div>
              )
              }
            >
              <motion.div
                layout
                layoutId={`chart-tile-${chartId}`} // Unique id for smooth transitions
                // key={`${tab?.title}-${prevActiveKey}`} // 👈 this is the fix
                key={chartId}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 20,
                }}
                initial={{ opacity: 0, scale: 0.2 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.1 }}
                style={{
                  padding: tab?.typ === 'future' ? 0 : 10,
                  background: "transparent",
                  color: "#fff",
                  height: tab?.typ === 'forex' ? "100%" : "100%",
                  position: "relative",
                  borderRadius: 10,
                }}
                className={`mobile-pdg ${tab?.typ === 'forex' && tab?.chartType === 'trade' ? 'forex-pdg' : ''}`}
              >
                {tab ? (
                  loadingCharts.includes(chartId) ? (
                    <Loader />
                  ) : // ✅ Show the chart if tab exists
                    // tab?.typ === "forex" || tab?.typ === "future" ? (

                    tab?.chartType === "trade" ? (
                      <Forexchart
                        chartId={`forex_${chartIndex}`}
                        tab={tab}
                        forceCompact={isCompactTile}
                      // onTabType={(type) => {
                      //   console.log(type, 'typeTABTYPE');
                      //   setActiveTabType(type)
                      // }
                      // }

                      />
                    ) : (

                      <LiveHighChart
                        chartId={chartId}
                        tab={tab}
                        // key={`${chartId}-${tab.key}`} // this tells React “this is a new tab”
                        key={tab.uid}
                        forceCompact={isCompactTile}
                        isMatchedIndex={chartIndex}
                      />

                    )
                ) : (
                  // ❌ Show Add Tab button if no tab matches

                  <BarsOutlined className="ad-chart" onClick={showDrawer} />
                )}

              </motion.div>
            </MosaicWindow >
          );
        }}
        value={currentLayout}
        onChange={(newNode) => setCurrentLayout(newNode)}
      />
      {/* <DropDown /> */}
    </div >
  );
}
